'use client';

import { Box } from '@/primitives';
import type { GetSaleLotsRow } from '../constants';
import SaleCatalogueDetailAnimalCard from './SaleCatalogueDetailAnimalCard';
import { useDeferredReveal } from './useDeferredReveal';

/** Avoid mounting hundreds of image-fetching cards when ALL is selected. */
export function DeferredSaleLotCard({
  row,
  cacheKey,
}: {
  row: GetSaleLotsRow;
  /** Remembers the card's height under this key. See useDeferredReveal. */
  cacheKey?: string;
}) {
  const { ref, visible, placeholderHeight } = useDeferredReveal(cacheKey, 360);

  return (
    <Box
      ref={ref}
      sx={{
        minHeight: visible ? undefined : placeholderHeight,
        height: '100%',
      }}
    >
      {visible && <SaleCatalogueDetailAnimalCard {...row} />}
    </Box>
  );
}
